import React from "react";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import MDContainer from "@mui/material/Container";
import usePictureSetsAvailableToBuyDigitally from "../../../hooks/usePictureSetsAvailableToBuyDigitally";
import PictureSetItem from "@/react/Webshop/Mobile/Pages/DigitalPortraits/PictureSetItem";

const DigitalPortarits = () => {
  const availablePictureSetForBuying = usePictureSetsAvailableToBuyDigitally();

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Buy digital files</Trans>
      </PageHeader>
      <MDContainer maxWidth="md">
        {availablePictureSetForBuying &&
          availablePictureSetForBuying.map((pictureSet) => {
            return (
              <PictureSetItem
                key={pictureSet.subject.uuid}
                pictureSet={pictureSet}
              />
            );
          })}
      </MDContainer>
    </MobilePage>
  );
};

export default DigitalPortarits;
